import api from '../../api';
import { IPayloadLogin } from './auth-interface';

class AuthService {
  login(payload: IPayloadLogin) {
    return api.post('/auth/login/', payload);
  }

  resetPassword(email: string) {
    return api.post('/auth/passwordReset', {
      email
    });
  }

  changePassword({ oldPassword, newPassword, token }: { oldPassword: string; newPassword: string; token: string }) {
    return api.put(
      '/auth/changePassword',
      {
        oldPassword,
        newPassword
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
  }

  refresh() {
    return api.get('/auth/refreshToken');
  }
}

export default new AuthService();
